import { render, staticRenderFns } from "./AttentionAppsIndicators.vue?vue&type=template&id=7912eb92&scoped=true&lang=pug"
import script from "./AttentionAppsIndicators.vue?vue&type=script&lang=js"
export * from "./AttentionAppsIndicators.vue?vue&type=script&lang=js"
import style0 from "./AttentionAppsIndicators.vue?vue&type=style&index=0&id=7912eb92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7912eb92",
  null
  
)

export default component.exports